import {Component} from 'react'
import {Link, withRouter} from 'react-router-dom'
import Cookies from 'js-cookie'
import Popup from 'reactjs-popup'
import 'reactjs-popup/dist/index.css'

import {FaMoon} from 'react-icons/fa'
import {FiSun, FiLogOut} from 'react-icons/fi'
import {IoMenu, IoClose} from 'react-icons/io5'
import {AiFillHome} from 'react-icons/ai'
import {HiFire} from 'react-icons/hi'
import {SiYoutubegaming} from 'react-icons/si'
import {CgPlayListAdd} from 'react-icons/cg'

import ModeContext from '../../context/ModeContext'

import {
  Nav,
  Logo,
  IconsCardSm,
  IconsCard,
  Button,
  Li,
  List,
  ProfileImg,
  Logout,
  LogoutCard,
  LOText,
  LOBtns,
  LOButton,
  Menu,
} from './styledComponents'

import './index.css'

class Header extends Component {
  render() {
    return (
      <ModeContext.Consumer>
        {value => {
          const {isDarkMode, changeMode, path, changePath} = value

          const sidebarListItem = isDarkMode ? 'white-list' : 'dark-list'

          const HomeCurrent = path === 'Home' ? 'hightLight' : ''
          const TrendingCurrent = path === 'Trending' ? 'hightLight' : ''
          const GamingCurrent = path === 'Gaming' ? 'hightLight' : ''
          const SavedCurrent = path === 'Saved' ? 'hightLight' : ''

          const onClickTrending = () => {
            changePath('Trending')
          }
          const onClickHome = () => {
            changePath('Home')
          }
          const onClickGaming = () => {
            changePath('Gaming')
          }
          const onClickSaved = () => {
            changePath('Saved')
          }

          const onChangeMode = () => {
            changeMode()
          }

          const onClickLogout = () => {
            const {history} = this.props
            Cookies.remove('jwt_token')
            history.replace('/login')
          }

          return (
            <Nav dark={isDarkMode}>
              <Link to="/" onClick={onClickHome}>
                <Logo
                  src={
                    isDarkMode
                      ? 'https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-dark-theme-img.png'
                      : 'https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-light-theme-img.png'
                  }
                  alt="website logo"
                />
              </Link>

              <IconsCardSm>
                <Button
                  onClick={onChangeMode}
                  data-testid="theme"
                  dark={isDarkMode}
                >
                  {isDarkMode ? <FiSun dark={isDarkMode} /> : <FaMoon />}
                </Button>

                <div className="popup-container">
                  <Popup
                    modal
                    trigger={
                      <Button dark={isDarkMode}>
                        <IoMenu dark={isDarkMode} />
                      </Button>
                    }
                  >
                    {close => (
                      <Menu dark={isDarkMode}>
                        <Button
                          data-testid="closeButton"
                          className="close"
                          onClick={() => close()}
                        >
                          <IoClose />
                        </Button>
                        <ul className="sidebar-options">
                          <Li
                            dark={isDarkMode}
                            active={HomeCurrent}
                            onClick={onClickHome}
                            to="/"
                            className={`link ${sidebarListItem}`}
                          >
                            <li key="1" className={HomeCurrent}>
                              {' '}
                              <AiFillHome /> <List dark={isDarkMode}>Home</List>
                            </li>
                          </Li>
                          <Li
                            dark={isDarkMode}
                            active={TrendingCurrent}
                            onClick={onClickTrending}
                            to="/trending"
                            className={`link ${sidebarListItem}`}
                          >
                            <li key="2" className={TrendingCurrent}>
                              <HiFire />
                              <List dark={isDarkMode}>Trending</List>
                            </li>
                          </Li>
                          <Li
                            dark={isDarkMode}
                            active={GamingCurrent}
                            onClick={onClickGaming}
                            to="/gaming"
                            className={`link ${sidebarListItem}`}
                          >
                            <li key="3" className={GamingCurrent}>
                              {' '}
                              <SiYoutubegaming />{' '}
                              <List dark={isDarkMode}>Gaming</List>
                            </li>
                          </Li>
                          <Li
                            dark={isDarkMode}
                            active={SavedCurrent}
                            onClick={onClickSaved}
                            to="/saved-videos"
                            className={`link ${sidebarListItem}`}
                          >
                            <li key="4" className={SavedCurrent}>
                              {' '}
                              <CgPlayListAdd />{' '}
                              <List dark={isDarkMode}>Saved Videos</List>
                            </li>
                          </Li>
                        </ul>
                      </Menu>
                    )}
                  </Popup>
                </div>

                <div className="popup-container">
                  <Popup
                    modal
                    trigger={
                      <Button dark={isDarkMode}>
                        <FiLogOut dark={isDarkMode} />
                      </Button>
                    }
                  >
                    {close => (
                      <LogoutCard dark={isDarkMode}>
                        <LOText dark={isDarkMode}>
                          Are you sure, you want to logout?
                        </LOText>
                        <LOBtns>
                          <LOButton
                            data-testid="closeButton"
                            onClick={() => close()}
                          >
                            Cancel
                          </LOButton>
                          <LOButton onClick={onClickLogout} logout>
                            Confirm
                          </LOButton>
                        </LOBtns>
                      </LogoutCard>
                    )}
                  </Popup>
                </div>
              </IconsCardSm>

              <IconsCard>
                <ul className="ul">
                  <li key="1" className="li">
                    <Button
                      data-testid="theme"
                      onClick={onChangeMode}
                      dark={isDarkMode}
                    >
                      {isDarkMode ? <FiSun dark={isDarkMode} /> : <FaMoon />}
                    </Button>
                  </li>
                  <li key="2" className="li">
                    <Button>
                      <ProfileImg
                        src="https://assets.ccbp.in/frontend/react-js/nxt-watch-profile-img.png"
                        alt="profile"
                      />
                    </Button>
                  </li>
                  <li key="3" className="li">
                    <div>
                      <Popup
                        modal
                        trigger={<Logout dark={isDarkMode}>Logout</Logout>}
                      >
                        {close => (
                          <LogoutCard dark={isDarkMode}>
                            <LOText dark={isDarkMode}>
                              Are you sure, you want to logout?
                            </LOText>
                            <LOBtns>
                              <LOButton
                                data-testid="closeButton"
                                onClick={() => close()}
                              >
                                Cancel
                              </LOButton>
                              <LOButton onClick={onClickLogout} logout>
                                Confirm
                              </LOButton>
                            </LOBtns>
                          </LogoutCard>
                        )}
                      </Popup>
                    </div>
                  </li>
                </ul>
              </IconsCard>
            </Nav>
          )
        }}
      </ModeContext.Consumer>
    )
  }
}

export default withRouter(Header)

// <Ul dark={isDarkMode}>
//                           {sidebarItems.map(each => {
//                             const to =
//                               each.text === 'Home'
//                                 ? '/'
//                                 : `/${each.text.toLowerCase()}`
//                             const onClickTab = () => {
//                               console.log(each.text)
//                               changePath(each.text)
//                             }

//                             return (
//                               <LINK to={to} key={each.text}>
//                                 <Li
//                                   dark={isDarkMode}
//                                   key={each.text}
//                                   id={`${each.id === activeTabId}${isDarkMode}`}
//                                   onClick={onClickTab}
//                                 >
//                                   {each.icon}
//                                   <List dark={isDarkMode}>{each.text}</List>
//                                 </Li>
//                               </LINK>
//                             )
//                           })}
//                         </Ul>
